import { db } from '../firebase';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';

let cachedSettings = null;
let cacheTime = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const getCachedSettings = () => cachedSettings;

export const fetchSettings = async () => {
  if (cachedSettings && cacheTime && Date.now() - cacheTime < CACHE_DURATION) {
    return cachedSettings;
  }

  const docRef = doc(db, 'settings', 'storeLocation');
  const docSnap = await getDoc(docRef);
  
  if (!docSnap.exists()) {
    throw new Error('Settings not configured. Please configure settings from admin app.');
  }
  
  cachedSettings = docSnap.data();
  cacheTime = Date.now();
  return cachedSettings;
};

export const subscribeToSettings = (callback) => {
  const docRef = doc(db, 'settings', 'storeLocation');
  
  return onSnapshot(docRef, (docSnap) => {
    if (!docSnap.exists()) {
      throw new Error('Settings not configured. Please configure settings from admin app.');
    }
    
    const settings = docSnap.data();
    cachedSettings = settings;
    cacheTime = Date.now();
    callback(settings);
  }, (error) => {
    throw new Error(`Error subscribing to settings: ${error.message}`);
  });
};
